





























































































































































import { Component, Vue, Prop, Emit, InjectReactive } from 'vue-property-decorator';
import { GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts_paycheckDraftLines, GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations } from '@/queries/__generated__/paycheckDataForPaycheckListForm';
import { GQL_PaycheckDraftLineSave } from '@/queries/global';
import { generateUID } from '@/utils/utils';
import { ALL_CARS } from '@/queries/Car';
import { ALL_PROJECTS } from '@/queries/Project';
import { ALL_DEPARTMENTS } from '@/queries/Department';
import { GQL_currentUnitCars_currentUnit_cars } from '@/queries/__generated__/currentUnitCars';
import { GQL_currentUnitProjects_currentUnit_projects } from '@/queries/__generated__/currentUnitProjects';
import { GQL_currentUnitDepartments_currentUnit_departments } from '@/queries/__generated__/currentUnitDepartments';
import { SmartQuery } from 'vue-apollo-decorator';
import { PaycheckLineTemplateMap } from './PaycheckDraftPeriodForm.vue';
import { GQL_paycheckLineTemplates_currentUnit_subUnits_workRelations_paycheckLineTemplates } from '@/queries/__generated__/paycheckLineTemplates';

@Component
export default class PaycheckDraftPeriodFormPaycheckDraftLine extends Vue {
  @SmartQuery({query: ALL_CARS, update: data => data.currentUnit.cars}) private cars!: GQL_currentUnitCars_currentUnit_cars[];
  @SmartQuery({query: ALL_PROJECTS, update: data => data.currentUnit.projects}) private projects!: GQL_currentUnitProjects_currentUnit_projects[];
  @SmartQuery({query: ALL_DEPARTMENTS, update: data => data.currentUnit.departments}) private departments!: GQL_currentUnitDepartments_currentUnit_departments[];

  @Prop({ type: Boolean, required: true }) private allowRemoveLine!: boolean;
  @Prop({ type: Object, required: true }) private workRelation!: GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations;
  @Prop({ type: Object, required: true }) private paycheckDraftLine!: GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts_paycheckDraftLines & GQL_PaycheckDraftLineSave;

  @InjectReactive() private editable!: boolean;
  @InjectReactive() private paycheckLineTemplatesMap!: PaycheckLineTemplateMap;
  private uid = generateUID();

  @Emit()
  private removeLine(): GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts_paycheckDraftLines & GQL_PaycheckDraftLineSave {
    return this.paycheckDraftLine;
  }

  private get calculatePositive(): boolean {
    const paycheckLineTemplate = this.paycheckLineTemplatesMap[this.workRelation.id].find(l => l.id === this.paycheckDraftLine.paycheckLineTemplateId);

    if (paycheckLineTemplate && paycheckLineTemplate.mainPaycheckLineTemplate) {
      return paycheckLineTemplate.mainPaycheckLineTemplate.calculatePositive;
    } else {
      return true;
    }
  }

  private paycheckLineTemlateDisplay(template: GQL_paycheckLineTemplates_currentUnit_subUnits_workRelations_paycheckLineTemplates) {
    const descriptionElements: {[key: string]: string} = {};
      descriptionElements["mainPaycheckLineTemplate"] = template.mainPaycheckLineTemplate.description;
    if(template.car) {
      const car = this.cars.find(car => car.id === template.car?.id);
      descriptionElements["car"] = `${car?.registrationNumber} - ${car?.name!}`;
    }
    if(template.project) {
      const project = this.projects.find(p=>p.id === template.project?.id);
      descriptionElements["project"] = `${project?.code} - ${project?.name!}`;
    }
    if(template.department) {
      const department = this.departments.find(d=>d.id === template.department?.id);
      descriptionElements["department"] = `${department?.code} - ${department?.name!}`;
    }
    return descriptionElements;
  }

  private updateFromTemplate(template: GQL_paycheckLineTemplates_currentUnit_subUnits_workRelations_paycheckLineTemplates) {
    if (template) {
      if (
        this.paycheckDraftLine.rate.isZero() &&
        this.paycheckDraftLine.quantity.isZero() &&
        this.paycheckDraftLine.sum.isZero()
      ) {
        this.paycheckDraftLine.rate = template.rate;
        this.paycheckDraftLine.quantity = template.quantity;
        this.paycheckDraftLine.sum = template.sum;
      }
      this.paycheckDraftLine.carId = template.car?.id;
      this.paycheckDraftLine.carOverwrite = template.carOverwrite;
      this.paycheckDraftLine.projectId = template.project?.id;
      this.paycheckDraftLine.projectOverwrite = template.projectOverwrite;
      this.paycheckDraftLine.departmentId = template.department?.id;
      this.paycheckDraftLine.departmentOverwrite = template.departmentOverwrite;
    }
  }

  private calculateSum(): void {
    if (
      !this.paycheckDraftLine.rate.isZero() &&
      !this.paycheckDraftLine.quantity.isZero() &&
      this.paycheckDraftLine.sum.isZero()
    ) {
      this.paycheckDraftLine.sum = this.paycheckDraftLine.quantity.times(this.paycheckDraftLine.rate);
    }
  }

  private get paycheckLineTemplatesForAutocomplete(): GQL_paycheckLineTemplates_currentUnit_subUnits_workRelations_paycheckLineTemplates[] {
    return this.paycheckLineTemplatesMap[this.workRelation.id]
      .filter(template => template.active)
      .sort((line1, line2) => {
        if (!line1.mainPaycheckLineTemplate?.id || !line2?.mainPaycheckLineTemplate?.id) return 0;
        return line1.mainPaycheckLineTemplate.number - line2.mainPaycheckLineTemplate.number;
      });
  }
}
